export default __webpack_public_path__ + "static/hover-dont-dark-5e7d3ccc8b3c044f7909f62815646b24.png";